import React, { useState } from "react";
import {
    Box,
    Autocomplete,
    TextField,
    Stack,
    IconButton,
    Button,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import HorizontalFlex from "components/lib-ui/HorizontalFlex";
import { GlobalAppDataStorageService } from "infra/storage";

export const LanguagesForm = ({ setIsDialogOpen, language, setLanguage }) => {

    const languageOptions = GlobalAppDataStorageService.getLanguages();
    const languageLevelOptions =
        GlobalAppDataStorageService.getLanguageLevels();
    const { setValue } = useFormContext();

    const [languagePairs, setLanguagePairs] = useState(language || []);

    const addLanguagePair = () => {
        setLanguagePairs((oldLanguagePairs) => [
            ...oldLanguagePairs,
            { language: null, language_level: null },
        ]);
    };

    const deleteLanguagePair = (index) => {
        const updatedPairs = [...languagePairs];
        updatedPairs.splice(index, 1);
        setLanguagePairs(updatedPairs);
    };

    const submitForm = () => {
        // Filter out pairs where either language or language_level is null
        const filteredPairs = languagePairs.filter(
            (pair) => pair.language !== null && pair.language_level !== null
        );

        

        setLanguage(filteredPairs);
        setValue("personalInformation.languages", filteredPairs);
        setIsDialogOpen(false);
       
    };

    const handleLanguageChange = (index, newValue) => {
        const updatedPairs = [...languagePairs];
        updatedPairs[index].language = newValue;
        setLanguagePairs(updatedPairs);
    };

    const handleLevelChange = (index, newValue) => {
        const updatedPairs = [...languagePairs];
        updatedPairs[index].language_level = newValue;
        setLanguagePairs(updatedPairs);
    };

    return (
        <Box>

            {languagePairs?.map((pair, index) => (
                <HorizontalFlex key={index} sx={{ marginTop: "1rem", marginBottom: "1rem" }} gap={2}>
                    <Autocomplete
                        fullWidth
                        autoComplete
                        options={languageOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                        }
                        value={pair.language}
                        onChange={(_, newValue) =>
                            handleLanguageChange(index, newValue)
                        }
                        renderInput={(params) => (
                            <TextField
                                variant="standard"
                                {...params}
                                label="Language"
                            />
                        )}
                    />
                    <Autocomplete
                        fullWidth
                        autoComplete
                        defaultValue={pair.language_level || null}
                        options={languageLevelOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                        }
                        value={pair.language_level}
                        onChange={(_, newValue) =>
                            handleLevelChange(index, newValue)
                        }
                        renderInput={(params) => (
                            <TextField
                                variant="standard"
                                {...params}
                                label="Level"
                            />
                        )}
                    />
                    <IconButton
                        aria-label="Delete"
                        onClick={() => deleteLanguagePair(index)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </HorizontalFlex>
            ))}

            <Stack direction="row" spacing={2} justifyContent="space-between">
                <Button
                    sx={{
                        borderRadius: "50px",
                        padding: "10px 30px",
                    }}
                    size="small"
                    color="primary"
                    variant="contained"
                    onClick={addLanguagePair}
                >
                    + Add Language
                </Button>
                <LoadingButton
                    sx={{
                        borderRadius: "50px",
                        padding: "10px 30px",
                    }}
                    size="small"
                    color="primary"
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    onClick={submitForm}
                >
                    Save changes
                </LoadingButton>
            </Stack>
        </Box>
    );
};
export default LanguagesForm;
